import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Nav from './components/Nav'
import Vue2TouchEvents from 'vue2-touch-events'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import { trackView, listenForUpdates } from './tracking'
import { applySeo, AMARI_MODE } from './seo'

// Адрес API задаётся при сборке: VUE_APP_API_URL=https://apiv2.abaata.ru npm run build
// Без переменной сайт работает со старым API. Новый бэкенд отвечает на те же адреса /list/… и /api/import-lead.
const LEGACY_API = 'https://api.abaata.ru'
const API_URL = (process.env.VUE_APP_API_URL || LEGACY_API).replace(/\/+$/, '')
if (API_URL !== LEGACY_API) {
  axios.interceptors.request.use(config => {
    if (config.url && config.url.indexOf(LEGACY_API) === 0) config.url = API_URL + config.url.slice(LEGACY_API.length)
    return config
  })
}

Vue.config.productionTip = false
Vue.use(Vue2TouchEvents)
Vue.use(VueCookies, { expires: '5min'})
Vue.component('Nav', Nav)
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent);
  },

  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
})

// плавное появление блока при попадании в экран; при reduced-motion и без IntersectionObserver ничего не делает
const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
Vue.directive('reveal', {
  inserted (el, binding) {
    if (reduceMotion || !('IntersectionObserver' in window)) return
    const delay = Number(binding.value) || 0
    el.classList.add('rv')
    el.style.setProperty('--rv-d', delay + 'ms')
    const io = new IntersectionObserver(entries => {
      if (!entries[0].isIntersecting) return
      io.disconnect()
      requestAnimationFrame(() => el.classList.add('rv--in'))
      // после показа убираем служебные классы, чтобы не мешать hover-эффектам карточек
      setTimeout(() => {
        el.classList.remove('rv', 'rv--in')
        el.style.removeProperty('--rv-d')
      }, 700 + delay)
    }, { rootMargin: '0px 0px -8% 0px' })
    el._io = io
    io.observe(el)
  },
  unbind (el) { if (el._io) el._io.disconnect() }
})

const SITES = ['abaata', 'pitsunda', 'picunda', 'amari']
// страницы, доступные на сайтах Пицунды и Amari (на сайте Абаата доступно всё)
const PITSUNDA_ROUTES = ['Abaata', 'selectSite', 'booking', 'Offers', 'contacts', 'price', 'Gallery', 'offer', 'services', 'service']
const ALLOWED_ROUTES = {
  pitsunda: PITSUNDA_ROUTES,
  picunda: PITSUNDA_ROUTES,
  amari: PITSUNDA_ROUTES
}

// на домене Amari (сборка VUE_APP_SITE=amari) отель один, и в адресе его названия нет
const siteFromUrl = AMARI_MODE ? 'amari' : window.location.pathname.split('/')[1]

var vue = new Vue({
  router,
  data () {
    return {
      site: SITES.includes(siteFromUrl) ? siteFromUrl : (localStorage.getItem('loadSiteNew') || null)
    }
  },
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
  if (to.name === 'selectSite') return next()
  const site = to.params.site || vue.site
  if (!SITES.includes(site)) next('/')
  else if (site === 'abaata' || ALLOWED_ROUTES[site].includes(to.name)) next()
  else next('/' + site)
})

const setSiteTitle = (site) => applySeo(site, router.currentRoute)
// Счётчик посещений и подписка на обновления. Хук afterEach не срабатывает для самой первой страницы, поэтому вызывается и из onReady.
function startSiteHooks (route) {
  if (!SITES.includes(vue.site)) return
  trackView(vue.site, route)
  listenForUpdates(vue.site, () => {
    // данные сайта изменились. Форму бронирования не перезагружаем: человек мог начать её заполнять
    if (router.currentRoute.name === 'booking') {
      if (!document.getElementById('site-updated-banner')) {
        const b = document.createElement('div')
        b.id = 'site-updated-banner'
        b.setAttribute('role', 'status')
        b.style.cssText = 'position:fixed;left:50%;bottom:20px;transform:translateX(-50%);z-index:2000;background:#2b241b;color:#fff;padding:12px 18px;border-radius:10px;font:15px/1.4 sans-serif;box-shadow:0 8px 24px rgba(0,0,0,.3)'
        b.innerHTML = 'Цены или номера обновились. <a href="" style="color:#d6b46e;margin-left:8px">Обновить страницу</a>'
        document.body.appendChild(b)
      }
    } else {
      setTimeout(() => window.location.reload(), 1500)
    }
  })
}

router.onReady(() => {
  setSiteTitle(router.currentRoute.params.site)
  startSiteHooks(router.currentRoute)
})
router.afterEach((route, from) => {
  // после перехода между страницами фокус уходит на содержимое (для экранных дикторов и клавиатуры)
  if (from.name) Vue.nextTick(() => { const m = document.getElementById('main'); if (m) m.focus({ preventScroll: true }) })
  vue.site = route.params.site
  if (SITES.includes(vue.site)) localStorage.setItem('loadSiteNew', vue.site)
  setSiteTitle(vue.site)

  // новый бэкенд: счётчик посещений и автообновление после правок в админке (при старом API ничего не делают)
  startSiteHooks(route)
})
